import styled from 'styled-components';

export default styled.div`
  background-color: ${(props) => props.theme.colors.black};
  height: fit-content;
  display: flex;
  align-items: center;
  padding: 20px 0;

  .search-menu-row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .inline-search-items {
    justify-content: flex-start;
  }

  h2 {
    color: ${(props) => props.theme.colors.white};
    font-size: 30px;
  }

  hr {
    margin: 20px 0;
  }

  .view-more-button {
    font-family: Vodafone Rg;
    padding: 10px 8px 6px;
    text-transform: none;
    font-family: Vodafone Rg;
    color: #333333;
    font-size: 22px;
    width: 100%;
  }

  .sku-group-search {
    width: 100% !important;
  }

  .sku-group__input > Label {
    width: 100%;
  }

  .sku-group-search {
    width: fit-content;
    display: inline-block;
  }

  .close_div {
    width: 100%;
    display: flex;
    flex: 1;
  }

  .close_div > Button {
    margin-left: auto;
    display: flex;
    vertical-align: middle;
    padding: 2px 8px;
  }
`;
